var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3132 14.684H2.87079C1.56598 14.684 0.5 13.618 0.5 12.3132V2.87079C0.5 1.56598 1.56598 0.5 2.87079 0.5H12.3132C13.618 0.5 14.684 1.56598 14.684 2.87079V12.3132C14.684 13.6238 13.6238 14.684 12.3132 14.684Z",
    stroke: "#173F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02008 10.1684C5.70744 10.8558 6.62197 11.2344 7.59475 11.2344C8.56753 11.2344 9.47624 10.8558 10.1694 10.1684C10.8568 9.48109 11.2354 8.56656 11.2354 7.59377C11.2354 6.62099 10.8568 5.70646 10.1694 5.01911C9.48206 4.33175 8.56753 3.95312 7.59475 3.95312C6.62197 3.95312 5.70744 4.33175 5.02008 5.01911C4.33273 5.70646 3.9541 6.62099 3.9541 7.59377C3.9541 8.56656 4.33273 9.48109 5.02008 10.1684Z",
    stroke: "#173F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9451 3.83554C12.3312 3.83554 12.6441 3.52258 12.6441 3.13652C12.6441 2.75046 12.3312 2.4375 11.9451 2.4375C11.5591 2.4375 11.2461 2.75046 11.2461 3.13652C11.2461 3.52258 11.5591 3.83554 11.9451 3.83554Z",
    stroke: "#173F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.eb33b40f1ce91b93657cd03b2ef30e6b.svg";
export { ForwardRef as ReactComponent };